// assets
import { Story, BoxAdd, Box1, DollarSquare, BoxTime, Calculator, Candle, Graph, Bank, Activity, Task, Note } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  widgets: Story,
  list: Box1,
  prices: DollarSquare,
  create: BoxAdd,
  live: BoxTime,
  calculator: Calculator,
  historicData: Candle,
  strategies: Graph,
  brokers: Bank,
  recommendationTrades: Activity,
  recommendationList: Task,
  decision: Note
};

// ==============================|| MENU ITEMS - SIMULATION ||============================== //
// TODO: fix translation error=> remove other languages
const recommendations: NavItemType = {
  id: 'recommendations',
  title: 'Recommendations',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'recommendation-trades',
      title: 'Recommendation Trades',
      type: 'item',
      url: '/recommendations',
      icon: icons.recommendationTrades
    },
    {
      id: 'recommendation-list',
      title: 'Recommendations',
      type: 'item',
      url: '/recommendation-list',
      icon: icons.recommendationList
    },
    {
      id: 'recommendation-decision',
      title: 'Decision Logs',
      type: 'item',
      url: '/recommendation-decision',
      icon: icons.decision
    }
  ]
};

export default recommendations;
